<div class="Dialog" mat-dialog-content>
  <div>
    @if (!isConfirming()) {
      <p>Search a SKU below to load attributes.</p>
      <div class="Flexbox Align--center Gap--smaller">
        <mat-form-field appearance="outline" class="SearchInput">
          <mat-label>Search</mat-label>
          <input matInput [(ngModel)]="newSKU" (keydown)="inputKeyDown($event)">
        </mat-form-field>
        <button mat-button class="ThemeColorAccent" (click)="searchSKU()">Search</button>
      </div>
    } @else {
      <p>Loading the attributes for this sku will overwrite your current selections. Are you sure you want to continue?</p>
    }
  </div>
  <mat-dialog-actions>
    @if (!isConfirming()) {
      <button mat-button [mat-dialog-close] class="ThemeColorAccent">Cancel</button>
    } @else {
      <button mat-button [mat-dialog-close]="newSKU">Yes, Overwrite</button>
      <button mat-button [mat-dialog-close] cdkFocusInitial>No, Keep Mine</button>
    }
  </mat-dialog-actions>
</div>